// extracted by mini-css-extract-plugin
export default {"btn":"ToolButton_btn__ZIgTQ","active":"ToolButton_active__h-Eja"};